document.addEventListener('DOMContentLoaded', function () {
  (function NewsletterOverlayManager() {
    // Cache commonly used nodes
    const overlay = document.querySelector('.tw-po-newsletter-overlay');
    const newsletterMsgs = Array.from(document.querySelectorAll('.newsletter-subscribe'));

    // Track currently visible messages to avoid unnecessary DOM writes
    const visibleMsgs = new Set();

    function openOverlayLinksInNewTabs() {
      if (!overlay) return;

      overlay.querySelectorAll('a[href]').forEach(link => {
        link.setAttribute('target', '_blank');

        const relValues = new Set(String(link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        relValues.add('noopener');
        relValues.add('noreferrer');
        link.setAttribute('rel', Array.from(relValues).join(' '));
      });
    }

    function positionMessages() {
      if (!overlay || newsletterMsgs.length === 0) return;
      // Insert each message only if it's not already adjacent to the overlay
      newsletterMsgs.forEach(msg => {
        if (msg.parentNode !== overlay.parentNode || msg.nextSibling !== overlay.nextSibling) {
          overlay.parentNode.insertBefore(msg, overlay.nextSibling);
        }
        // register initial visibility according to computed style
        if (msg.offsetParent !== null) visibleMsgs.add(msg);
      });
    }

    // Single delegated click handler for close buttons and outside clicks
    function delegatedClickHandler(event) {
      const target = event.target;

      // If clicked on a close button (or inside it), close only that message
      const closeBtn = target.closest && target.closest('.closeNewsletterMsg');
      if (closeBtn) {
        const container = closeBtn.closest('.newsletter-subscribe');
        if (container) {
          // minimize layout work: use class toggle instead of style mutations where possible
          container.classList.add('tw-hidden');
          visibleMsgs.delete(container);
        }
        return;
      }

      // If click is outside any visible newsletter message, close visible ones.
      // Optimize: check only visibleMsgs set rather than all messages.
      if (visibleMsgs.size === 0) return;

      // If click is inside any visible message, do nothing
      for (const msg of visibleMsgs) {
        if (msg.contains(target)) return;
      }

      // Close all visible messages
      visibleMsgs.forEach(msg => {
        msg.classList.add('tw-hidden');
      });
      visibleMsgs.clear();
    }

    function init() {
      openOverlayLinksInNewTabs();
      positionMessages();

      // Use a single delegated listener on document to handle closes and outside clicks.
      // This avoids adding multiple listeners and iterating over all messages on every click.
      document.addEventListener('click', delegatedClickHandler, { passive: true });
    }

    init();
  })();
});
